<template>
  <div :class="wrapSize">
    <div class="flex">
      <div class="w-full">
        <starred-item :starred="starred" :css-class="'justify-start'">
          <label :for="labelFor" class="inline-block text-80 leading-tight">{{label}}</label>
        </starred-item>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import StarredItem from '@mobile/components/StarredItem';

export default {
    name: 'InputControlToggle',
    components: { StarredItem },
    props: {
        wrapSize: {
            type: String,
            default: 'mb-6',
        },
        label: {
            type: String,
            default: '',
        },
        labelFor: {
            type: String,
            default: '',
        },
        starred: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
